<template>
    <expansion-panel
        icon="mdi-table"
        header="Accident Reports"
        v-if="hasPermission('staffAdminAccidentReports')"
    >
        <accident-report-table
            :reports="reports"
            @page-changed="pageChanged"
            :page="$page.props.accidentReports.current_page"
        />
    </expansion-panel>
</template>

<script>
import ExpansionPanel from "./ExpansionPanel.vue";
import Permissions from "../../../../Mixins/Permissions.js";
import AccidentReportTable from "../../AccidentReports/AccidentReportTable.vue";

export default {
    name: "AccidentReportsPanel",
    components: { AccidentReportTable, ExpansionPanel },
    mixins: [Permissions],

    props: {
        showUser: {
            type: Boolean,
            default: false,
        },
    },

    computed: {
        reports() {
            return this.$page.props.accidentReports;
        },
    },

    methods: {
        pageChanged(page) {
            this.$inertia.visit(this.route("admin.users.show", this.user.id), {
                method: "get",
                data: {
                    accidentPage: page,
                },
                only: ["accidentReports", "flash"],
                preserveScroll: true,
                preserveState: true,
            });
        },
    },
};
</script>

<style scoped></style>
